'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _ = require('lodash');
var GridColumnConditionallyEditableService = function GridColumnConditionallyEditableService(featureToggleService, directForecastingConfigurationService) {
  var conditions = {
    /**
     * Return true if given row is newly added
     *
     * @param loadedData
     * @param rowIndex
     * @returns {boolean}
     */
    isNewRow: function isNewRow(loadedData, rowIndex) {
      return loadedData[rowIndex].isNewlyAdded === true;
    },
    /**
     * Return true if given row is newly added or is duplicated
     *
     * @param loadedData
     * @param rowIndex
     * @returns {boolean}
     */
    isNewRowOrDuplicate: function isNewRowOrDuplicate(loadedData, rowIndex) {
      var row = loadedData[rowIndex];
      return row.isNewlyAdded === true || row.isRowEditable === true;
    },
    /**
     * Return true if given column's value is 'true'
     *
     * @param loadedData
     * @param rowIndex
     * @param datafield
     * @param value
     * @param columnName
     * @returns {boolean}
     */
    isColumnTrue: function isColumnTrue(loadedData, rowIndex, datafield, value, columnName) {
      return loadedData[rowIndex][columnName] === true;
    },
    checkParentPermission: function checkParentPermission(loadedData, rowIndex) {
      var row = loadedData[rowIndex];
      var parent = null;
      var editable = [];
      _.forEach(loadedData, function (item) {
        //parentIndex = row.parents.indexOf(item.component);
        parent = _.find(row.parents, ['component', item.component]);
        if (parent) {
          if (parent.privilege === 'WRITE') {
            editable.push(item.isEditable);
          } else if (parent.privilege === 'READ') {
            editable.push(item.isViewable);
          }
        } else if (row.component === 'data-extract' || row.component === 'history') {
          editable = false;
        }
      });
      if (editable.length === 0) {
        return true;
      }

      //This assumes an OR condition for parent permissions
      return _.reduce(editable, function (prev, curr) {
        return prev || curr;
      });
    },
    isRegularAdjustmentEditable: function isRegularAdjustmentEditable(loadedData, rowIndex, fieldName, fieldValue, dependencyField) {
      if (dependencyField && isDependencyFieldEmpty(loadedData[rowIndex], dependencyField)) {
        return false;
      }
      return featureToggleService.isEnabled('MAPPED_MODE');
    },
    isMappedAdjustmentEditable: function isMappedAdjustmentEditable(loadedData, rowIndex, fieldName, fieldValue, dependencyField) {
      if (dependencyField && isDependencyFieldEmpty(loadedData[rowIndex], dependencyField)) {
        return false;
      }
      return featureToggleService.isEnabled('SPOS') && checkIfRowHasDefaultPOS(loadedData[rowIndex]) || featureToggleService.isDisabled('SPOS');
    },
    isNotUserManagementComponent: function isNotUserManagementComponent(loadedData, rowIndex) {
      var rowData = loadedData[rowIndex];
      if (rowData.viewEnabled) {
        return rowData.component !== 'user-management';
      } else {
        return false;
      }
    },
    isNotMatchStrategy: function isNotMatchStrategy(loadedData, rowIndex, fieldName, fieldValue, dependencyField) {
      var isNotMatchStrategy = loadedData[rowIndex][dependencyField] !== 'MATCH';
      if (!isNotMatchStrategy) {
        if (fieldName === 'amount') {
          loadedData[rowIndex][fieldName] = 0;
        } else if (fieldName === 'percentageIndicator') {
          loadedData[rowIndex][fieldName] = 'A';
        }
      }
      return isNotMatchStrategy;
    },
    isDisabledWhenOrdinalMatching: function isDisabledWhenOrdinalMatching(loadedData, rowIndex, fieldName, fieldValue, dependencyField) {
      var isDisabledWhenOrdinalMatching = loadedData[rowIndex][dependencyField] !== 'ORDINAL';
      if (!isDisabledWhenOrdinalMatching) {
        if (fieldName === 'competitorEntryLevelRbds') {
          loadedData[rowIndex][fieldName] = null;
        }
      }
      return isDisabledWhenOrdinalMatching;
    },
    isDisabledWhenNotRbdToRbdMatching: function isDisabledWhenNotRbdToRbdMatching(loadedData, rowIndex, fieldName, fieldValue, dependencyField) {
      var isDisabledWhenNotRbdToRbdMatching = loadedData[rowIndex][dependencyField] === 'RBD TO RBD' && loadedData[rowIndex]['category'] === 'STRUCTURAL';
      if (!isDisabledWhenNotRbdToRbdMatching) {
        if (fieldName === 'useForLadderGeneration') {
          loadedData[rowIndex][fieldName] = true;
        }
      }
      return isDisabledWhenNotRbdToRbdMatching;
    },
    isNotLoadFactorTargetType: function isNotLoadFactorTargetType(loadedData, rowIndex, fieldName, fieldValue, dependencyField) {
      return loadedData[rowIndex][dependencyField] !== 'LoadFactor';
    },
    isNotThroughSegment: function isNotThroughSegment(loadedData, rowIndex) {
      return !isDependencyFieldEmpty(loadedData[rowIndex], 'legClassId');
    },
    isNotSpecialEvent: function isNotSpecialEvent(loadedData, rowIndex) {
      return !loadedData[rowIndex].isSpecialEvent;
    },
    isNotDiscontinued: function isNotDiscontinued(loadedData, rowIndex) {
      var isDiscontinuedRoutesEnabled = featureToggleService.isEnabled('DISCONTINUED_ROUTES');
      var isServiceDiscontinued = loadedData[rowIndex].isDiscontinued === 'Yes';
      return !(isDiscontinuedRoutesEnabled && isServiceDiscontinued);
    },
    isNotDirectForecasting: function isNotDirectForecasting(loadedData, rowIndex) {
      if (featureToggleService.isDisabled('DIRECT_FORECAST_ENABLE')) {
        return true;
      }
      return !directForecastingConfigurationService.isDirectForecastEnabled(loadedData[rowIndex]);
    },
    isNotSignificantMarket: function isNotSignificantMarket(loadedData, rowIndex) {
      return !loadedData[rowIndex]['isSignificantOriginal'];
    },
    isNotInOlapRequestQueue: function isNotInOlapRequestQueue(loadedData, rowIndex) {
      return !loadedData[rowIndex].isMarketInPendingOlapQueue;
    }
  };
  function checkIfRowHasDefaultPOS(rowData) {
    return !_.isNil(rowData.posName) && rowData.posName === 'Default' || !_.isNil(rowData.significantPOS) && rowData.significantPOS === 'Default';
  }
  function isDependencyFieldEmpty(rowData, fieldName) {
    return _.isNil(rowData[fieldName]);
  }
  function isColumnConditionallyEditable(editable) {
    return (0, _typeof2["default"])(editable) === 'object' && (_.includes(_.keys(conditions), editable.condition) || _.includes(editable.condition, ','));
  }
  function areEditableConditionsMet(editableCondition, params) {
    if (!_.includes(editableCondition, ',')) {
      return conditions[editableCondition].apply(null, params);
    }
    var conditionsToCheck = _.split(editableCondition, ',');
    return _.reduce(conditionsToCheck, function (result, condition) {
      if (result) {
        return conditions[condition].apply(null, params);
      } else {
        return false;
      }
    }, true);
  }
  return {
    isColumnConditionallyEditable: isColumnConditionallyEditable,
    areEditableConditionsMet: areEditableConditionsMet,
    isNewRow: conditions.isNewRow,
    isNewRowOrDuplicate: conditions.isNewRowOrDuplicate,
    isColumnTrue: conditions.isColumnTrue,
    checkParentPermission: conditions.checkParentPermission,
    isNotUserManagementComponent: conditions.isNotUserManagementComponent,
    isMappedAdjustmentEditable: conditions.isMappedAdjustmentEditable,
    isRegularAdjustmentEditable: conditions.isRegularAdjustmentEditable,
    isNotLoadFactorTargetType: conditions.isNotLoadFactorTargetType,
    isNotThroughSegment: conditions.isNotThroughSegment,
    isNotMatchStrategy: conditions.isNotMatchStrategy,
    isNotSpecialEvent: conditions.isNotSpecialEvent,
    isDisabledWhenOrdinalMatching: conditions.isDisabledWhenOrdinalMatching,
    isDisabledWhenNotRbdToRbdMatching: conditions.isDisabledWhenNotRbdToRbdMatching,
    isNotDiscontinued: conditions.isNotDiscontinued,
    isNotDirectForecasting: conditions.isNotDirectForecasting,
    isNotSignificantMarket: conditions.isNotSignificantMarket,
    isNotInOlapRequestQueue: conditions.isNotInOlapRequestQueue
  };
};
GridColumnConditionallyEditableService.$inject = ['FeatureToggleService', 'DirectForecastingConfigurationService'];
module.exports = GridColumnConditionallyEditableService;